
export { RevisionModule } from './revision.module';
export { RevisionListComponent } from './revision-list.component';
export { RevisionResolver } from './revision.resolver';
export { RevisionsResolver } from './revisions.resolver';